import React, {useState} from "react";
import {AccessibilityUnit} from "../../../../../../../../models/AccessibilityUnits";
import {Box, Grid} from "@material-ui/core";
import TopBlock from "./components/TopBlock";
import UnitList from "./components/unit-list/UnitList";
import ImagesList from "./components/images-list/ImagesList";
import {AccessibilityImages} from "../../../../../../../../models/AccessibilityImages";
import GeneralImageEditor from "./components/modals/general-image-editor/GeneralImageEditor";
import ImageEditor from "./components/modals/image-editor/ImageEditor";

const ImagesTab = () => {
  const [selectedUnit, setSelectedUnit] = useState<AccessibilityUnit | null>(null)
  const [showImageEditor, setShowImageEditor] = useState(false)
  const [showGeneralImageEditor, setShowGeneralImageEditor] = useState(false)
  const [editData, setEditData] = useState<AccessibilityImages | null>(null)
  const [forceUpdateById, setForceUpdateById] = useState<string | null>('')

  const handleSelectUnit = (unit: AccessibilityUnit) => {
    setSelectedUnit(unit)
  }

  const handleCloseImageEditor = (accessibility_unit: string | undefined) => {
    setShowImageEditor(false)
    setEditData(null)
    if (accessibility_unit) {
      setForceUpdateById(accessibility_unit)
    }
  }

  const handleCloseGeneralImageEditor = () => {
    setShowGeneralImageEditor(false)
  }

  return (
    <Box>
      <TopBlock
        selectedUnit={!!selectedUnit}
        onSetShowImageEditor={setShowImageEditor}
      />
      <ImageEditor
        data={editData}
        show={showImageEditor}
        onClose={handleCloseImageEditor}
      />
      <GeneralImageEditor
        show={showGeneralImageEditor}
        onClose={handleCloseGeneralImageEditor}
      />
      <Grid container spacing={5}>
        <Grid item xs={12} sm={5} md={4} lg={3}>
          <UnitList
            onShowGeneralImageEditor={setShowGeneralImageEditor}
            selectedUnit={selectedUnit}
            onSelectUnit={handleSelectUnit}
          />
        </Grid>
        <Grid item xs={12} sm={7} md={8} lg={9}>
          {selectedUnit ? (
            <ImagesList
              selectUnit={selectedUnit}
              forceUpdateById={forceUpdateById}
              onSetShowImageEditor={setShowImageEditor}
              onSetForceUpdateById={setForceUpdateById}
              onSetEditData={setEditData}
            />
          ) : null}
        </Grid>
      </Grid>
    </Box>
  )
}

export default ImagesTab